export enum ArtifactsViewerViewMode {
  STORYBOARD = "storyboard",
  TIMELINE = "timeline",
}
